import {gql} from 'apollo-angular'


const GET_USER_INFO = gql`
query UserById($id: String!) {
  userById(id: $id) {
    id
    username
    email
    firstName
    lastName
    isAdmin
    oldUserId
    createdDate
    updatedDate
    flagUser(orderBy: "-id") {
      edges {
        node {
          flagSpaceReference {
            flagSpace {
              space {
                name
                id
              }
              flag {
                name
                id
              }
            }
            reference
          }
          flagsspaceusersrolesSet {
            edges {
              node {
                flagSpaceRole {
                  name
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
`

const GET_USERS = gql`
query Users($isDeleted: Boolean = false, $flagSpaceReference_FlagSpace_Id: ID = "2", $flagUser_FlagSpaceReference_FlagSpace_Id: ID = "2") {
  Users(
    isDeleted: $isDeleted
    orderBy: "last_name"
    flagUser_FlagSpaceReference_FlagSpace_Id: $flagUser_FlagSpaceReference_FlagSpace_Id
  ) {
    edges {
      node {
        id
        firstName
        lastName
        email
        isActive
        agency
        endDate
        isActive
        birthDate
        civilTitle
        gender
        maritalStatus
        image
        startDate
        endDate
        createdDate
        updatedDate
        providercommissionratesSet(isDeleted: $isDeleted, last: 1) {
          edges {
            node {
              id
              rate
            }
          }
        }
        updatedBy {
          firstName
          lastName
        }
        flagUser(
          isDeleted: $isDeleted
          flagSpaceReference_FlagSpace_Id: $flagSpaceReference_FlagSpace_Id
        ) {
          edges {
            node {
              id
              flagsspaceusersrolesSet(isDeleted: $isDeleted) {
                edges {
                  node {
                    id
                    flagSpaceRole {
                      id
                      name
                      isActive
                    }
                  }
                }
              }
              flagSpaceReference {
                flagSpace {
                  space {
                    id
                    name
                    isActive
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`



export {GET_USER_INFO, GET_USERS}
